import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Users } from './pages/Users';
import { UserDetail } from './pages/UserDetail';
import { Dreams } from './pages/Dreams';
import { DreamDetail } from './pages/DreamDetail';
import { Notifications } from './pages/Notifications';
import { Categories } from './pages/Categories';
import { Profile } from './pages/Profile';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Layout data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Dashboard data-id="element-5" />} data-id="element-4" />
          <Route path="/users" element={<Users data-id="element-7" />} data-id="element-6" />
          <Route path="/users/:id" element={<UserDetail data-id="element-9" />} data-id="element-8" />
          <Route path="/dreams" element={<Dreams data-id="element-11" />} data-id="element-10" />
          <Route path="/dreams/:id" element={<DreamDetail data-id="element-13" />} data-id="element-12" />
          <Route path="/notifications" element={<Notifications data-id="element-15" />} data-id="element-14" />
          <Route path="/categories" element={<Categories data-id="element-17" />} data-id="element-16" />
          <Route path="/profile" element={<Profile data-id="element-19" />} data-id="element-18" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}